import { clsx } from 'clsx';
import type { HTMLAttributes } from 'react';
import React from 'react';
import { spacing } from '../../styles/spacing.css';
import { Layout } from '../Layout/Layout';
import type { LayoutProps } from '../Layout/Layout';
import type { TextVariants } from '../Text/Text';
import { Text } from '../Text/Text';
import type { TagVariants } from './Tag.css';
import * as styles from './Tag.css';

type TagSize = Exclude<NonNullable<TagVariants>['size'], undefined>;
type TextType = NonNullable<TextVariants>['type'];

const SIZE_TO_FONT_SIZE: Record<TagSize, TextType> = {
  sm: 'label',
  md: 'h6',
};

export type { TagVariants };

export const TAG_CONTAINER_TEST_ID = 'tag-container';

export type TagProps = HTMLAttributes<HTMLDivElement> & LayoutProps & TagVariants;

export const Tag: React.FC<TagProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className: externalClassName,
  ...props
}) => {
  return (
    <Layout
      className={clsx(styles.tag({ variant, size }), externalClassName)}
      height={spacing.s32}
      width="fit-content"
      {...props}
    >
      <Text type={SIZE_TO_FONT_SIZE[size]}>{children}</Text>
    </Layout>
  );
};
